"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var page_widget_element_1 = require("./designer-elements/page-widget.element");
var PageElementFactory = /** @class */ (function () {
    function PageElementFactory() {
    }
    PageElementFactory.prototype.create = function (domInfo) {
        if (this.elemIsWidget(domInfo)) {
            return new page_widget_element_1.PageWidgetElement(domInfo);
        }
        else {
            throw new TypeError("Unknown element in form designer");
        }
    };
    PageElementFactory.prototype.elemIsWidget = function (domInfo) {
        return domInfo.bagNameEquals(PageElementFactory.WIDGET_CARD_BAG);
    };
    PageElementFactory.WIDGET_CARD_BAG = 'widget-card-bag';
    return PageElementFactory;
}());
exports.PageElementFactory = PageElementFactory;
//# sourceMappingURL=page-element.factory.js.map